import { render, staticRenderFns } from "./WeeklySignFormScreen.vue?vue&type=template&id=968e38ec&"
import script from "./WeeklySignFormScreen.vue?vue&type=script&lang=ts&"
export * from "./WeeklySignFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports